import vi from './vi';
import en from './en';

const translations = {
  vi,
  en,
};

export default translations; 